import ArrowDown from "../assets/images/arrow-down.svg";

const layerStyles = {
  container: {
    w: "100%",
    maxW: ["100%", null, "816px"],
    px: ["15px", null, 0],
  },
  base: {
    // bgColor: "white",
    border: "1px solid #EBECEE",
    borderRadius: "4px",
    boxShadow: "0px 2px 14px 0px #0000001F",
  },
  homeHeader: {
    w: "100%",
    background:
      "linear-gradient(269.98deg, #FFCC00 0.13%, #E4B700 50.89%, #FFCC00 99.54%)",
  },
  paymentDropDown: {
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px",
    border: "none",
    borderRadius: "3px",
    h: "42px",
    _after: {
      content: "''",
      w: "12px",
      h: "6px",
      bgImage: ArrowDown,
      bgSize: "cover",
      bgRepeat: "no-repeat",
      // mr: "10px",
      cursor: "pointer",
      pos: "absolute",
      right: "24px",
    },
  },
};

export default layerStyles;
